// extracted by mini-css-extract-plugin
module.exports = {"cadence":"ResultCadence_cadence__1EYjN","header":"ResultCadence_header__2U3RK","desktop":"ResultCadence_desktop__2tfVG","smallDevice":"ResultCadence_smallDevice__1_EPe"};